import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { environment } from 'environments/environment';
import { StorageService } from 'app/services/storage.service';
import { AuthWebService } from 'app/services/authweb.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { EqualvalidatorDirective } from 'app/validators/equalvalidator.directive';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.css']
})
export class ResetComponent implements OnInit {
  form;
  params: any = {};
  loginUser: any = { };
  systemCode: String = null;
  correspondencechoice: string=null;
  public isLoading = false;
  message = null;

  constructor(public authWebService: AuthWebService,
    private router: Router,
    private route: ActivatedRoute,
     public utility: UtilityServiceService,private toastr:ToastrService) { }

  ngOnInit() {
    this.systemCode = environment.authWebApi.systemCode

    if(localStorage.getItem('isLogged') == 'true')
    {
      localStorage.clear();
      window.location.reload();
    }
    this.initForm();
  }
  initForm(){
    this.form = new UntypedFormGroup({
      EmailAddress: new UntypedFormControl("", Validators.compose([Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]))
    
    
  });
  
  }
  selectcorrespondenceType(typeVal){
    
    this.correspondencechoice=typeVal;
    
  }

  
  onSubmit(obj: any){

    if (this.correspondencechoice === null){
  
      return this.toastr.warning('Please select how you want to recieve the reset confirmation link!','Password Reset');
    
    }

    if (obj.EmailAddress === null)
    {
      return this.toastr.warning('Enter Email address!','Password Reset');
    }
    obj.EmailAddress=obj.EmailAddress.toLowerCase();
    //send to authweb
    this.authWebService.passwordResetRequest(obj.EmailAddress, this.systemCode, this.correspondencechoice === "2" ? "SMS" : "Email");
    
  }

 
}
